export function interceptor(router) {
  return router;
}
